import { render, staticRenderFns } from "./AllDocViewer.vue?vue&type=template&id=3b17b0aa&"
import script from "./AllDocViewer.vue?vue&type=script&lang=js&"
export * from "./AllDocViewer.vue?vue&type=script&lang=js&"
import style0 from "./AllDocViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports